import { useEffect } from 'react';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { useAuth } from '@/hooks/useAuth';

/**
 * This component initializes push notifications when the user is authenticated.
 * Place it in your App.tsx or main layout component.
 */
export const PushNotificationSetup = () => {
  const { session } = useAuth();
  const { isSupported, requestPermission } = usePushNotifications();

  useEffect(() => {
    // Only request push notification permission for authenticated users on native platforms
    if (session && isSupported) {
      // Auto-request permission on first app launch
      const hasRequestedBefore = localStorage.getItem('push_permission_requested');
      
      if (!hasRequestedBefore) {
        setTimeout(() => {
          requestPermission().then((granted) => {
            if (granted) {
              localStorage.setItem('push_permission_requested', 'true');
            }
          });
        }, 2000); // Delay to avoid overwhelming users on first launch
      }
    }
  }, [session, isSupported, requestPermission]);

  return null; // This component doesn't render anything
};
